import axios from "src/lib/axios";

const API_URLS = {
    GET_MOBILE_USERS: `/Users/GetAllUsers`,
};

const sourceKey = 'Globatech Dev';
const secret = '34D1973C-9606-4C30-9E3D-7F694C432768';

export const GetAllMobileUsers = async () => {
    const mobileUserGroups = await axios.get<any[]>(API_URLS.GET_MOBILE_USERS);
    return mobileUserGroups?.data || [];
};

export const GetConfigUsersList = async (email): Promise<any> => {
    const response = await axios.get<any>(
        `/ConfigAccount/GetConfigUsersList/${email}`
    );
    return response?.data;
};

export const GetNotificationRecipients = async (appKey): Promise<any> => {
    const response = await axios.get<any>(
      `/Notification/GetNotificationRecipients?appKey=${appKey}`
    );
    return response?.data || {};
  };

  export const SendNotificationMessage = async (data: any): Promise<any> => {
    const requestData = {
        ...data,
        sourceName: sourceKey,
        sourceId: secret
    };
    const response = await axios.post<any>(
        'Notification/SendNotification', requestData
    );
    return response?.data;
};

export const getNotificationMessageLogList = async (appKey, userKey): Promise<any> => {
    const response = await axios.get<any>(
      `/NotificationMessageLog/GetNotificationMessageLog?appKey=${appKey}&userKey=${userKey}`
    );
    return response?.data;
  };

export const deleteNotificationMessageLogData = async (notificationMessageLogKey): Promise<any> => {
    const response = await axios.post<any>(
        `/NotificationMessageLog/DeleteNotificationMessageLog/${notificationMessageLogKey}`
    );
    return response?.data;
};